import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Button} from "reactstrap"
import BulkProcessModal from "./BulkProcessModal"
import {bulkApproved, bulkRejected} from "../../../../../services/api/apiReGenerateLabel"
import ResultModal from "./ResultModal"
import PubSub from "pubsub-js"

class BulkActions extends Component {
    state = {
        isOpen: false,
        modal: false,
        loading: false,
        error: '',
        note: '',
        listSuccess: [],
        listError: [],
        modalResult: false
    }

    _openResult = () => {
        this.setState({
            modalResult: true
        })
    }

    _closeResult = () => {
        this.setState({
            isOpen: false,
            modal: false,
            loading: false,
            error: '',
            note: '',
            listSuccess: [],
            listError: [],
            modalResult: false
        }, () => {
            const {clearSelected} = this.props

            if (typeof clearSelected === 'function') {
                clearSelected()
            }

            PubSub.publish('LIST_RE_GENERATE')
        })
    }

    _toggleOpen = () => {
        this.setState({
            isOpen: !this.state.isOpen
        })
    }

    _handleChangeNote = (value) => {
        this.setState({
            note: value
        })
    }

    _onOpenProcess = () => {
        this.setState({
            modal: !this.state.modal
        })
    }

    _bulkApproved = async () => {
        this.setState({
            loading: 'approved',
            error: ''
        })

        try {
            const {arrSelected} = this.props
            const {note} = this.state
            const payload = {
                ids: arrSelected,
                content: note
            }

            const {data: response} = await bulkApproved(payload)

            const {success, message, data} = response

            if (!success) {
                return this.setState({
                    loading: false,
                    error: message
                })
            }

            this.setState({
                loading: false,
                isOpen: false,
                modal: false,
                listSuccess: data.success,
                listError: data.error
            }, () => {
                this._openResult()
            })
        } catch (error) {
            const {response} = error

            if (!response || typeof response !== 'object') {
                return this.setState({
                    error: error,
                    loading: false
                })
            }

            const {data} = response

            if(typeof data === 'object' && data.hasOwnProperty('message')) {
                return this.setState({
                    error: data.message,
                    loading: false
                })
            }

            this.setState({
                error: error.message,
                loading: false
            })

        }
    }

    _bulkRejected = async () => {
        this.setState({
            loading: 'rejected',
            error: ''
        })

        try {
            const {arrSelected} = this.props
            const {note} = this.state
            const payload = {
                ids: arrSelected,
                content: note
            }

            const {data: response} = await bulkRejected(payload)

            const {success, message, data} = response

            if (!success) {
                return this.setState({
                    loading: false,
                    error: message
                })
            }

            this.setState({
                loading: false,
                isOpen: false,
                modal: false,
                listSuccess: data.success,
                listError: data.error
            }, () => {
                this._openResult()
            })
        } catch (e) {
            this.setState({
                loading: false,
                error: e.message
            })
        }
    }

    render() {
        const {isOpen, modal, loading, error, listError, listSuccess, modalResult} = this.state
        const {onChange, selectAll, arrSelected} = this.props

        return (
            <tr className='BulkActionLabels'>
                <th>
                    <input type='checkbox' checked={selectAll} onChange={onChange}/>
                </th>
                <th className='Actions' colSpan={9}>
                    <div className="CustomSelect">
                        <Button onClick={this._toggleOpen}
                                className="dropdown-toggle">Actions</Button>
                        <div className={isOpen ? 'ListAction open' : 'ListAction'}>
                            <div className="GenerateLabel">
                                <Button color="link" onClick={this._onOpenProcess}>Duyệt generate labels</Button>
                            </div>
                        </div>
                        {
                            isOpen && <div className="Background" onClick={this._toggleOpen}/>
                        }
                        <span className='ml-3'>Bạn đã chọn {arrSelected.length} items</span>
                    </div>
                </th>
                <BulkProcessModal
                    loading={loading}
                    error={error}
                    isOpen={modal}
                    arrSelected={arrSelected}
                    onToggle={this._onOpenProcess}
                    onChangeNote={this._handleChangeNote}
                    onApproved={this._bulkApproved}
                    onRejected={this._bulkRejected}
                />

                <ResultModal
                    modalResult={modalResult}
                    listError={listError}
                    listSuccess={listSuccess}
                    onClose={this._closeResult}
                    onOpen={this._openResult}
                />
            </tr>
        )
    }
}

BulkActions.propTypes = {
    onChange: PropTypes.func.isRequired,
    selectAll: PropTypes.bool,
    arrSelected: PropTypes.array,
    clearSelected: PropTypes.func.isRequired
}

export default BulkActions